import { render, staticRenderFns } from "./LayoutEdit.vue?vue&type=template&id=5ffacd94"
import script from "./LayoutEdit.vue?vue&type=script&lang=ts"
export * from "./LayoutEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports